<template>
  <div class="attribution">
    Challenge by
    <a href="https://www.frontendmentor.io?ref=challenge" target="_blank"
      >Frontend Mentor</a
    >. Coded by <a href="#">Pony Ma</a>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.attribution {
  font-size: 11px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  position: fixed;
  bottom: 10px;
}

.attribution a {
  color: hsl(228, 45%, 44%);
}
</style>